import { forEach as lodashForEach, get as lodashGet, shuffle as lodashShuffle } from 'lodash'
import { PURPOSES } from '@/constant/UserScreening.constants'
// Not pure function
export function getPurposes() {
  lodashForEach(PURPOSES, (val, key) => {
    let professions = lodashGet(val, 'professions', [])
    const optionOther = professions.pop()

    professions = lodashShuffle(professions)
    professions.push(optionOther)

    PURPOSES[key].professions = professions
  })

  return PURPOSES
}
